import { Button } from "antd";
import { translate } from "utils";
import { ExportOutlined } from "@ant-design/icons";

export function ExportBtn({
	onClick,
	htmlType = "button",
	loading = false,
}: {
	onClick?: () => void;
	htmlType?: "button" | "submit";
	loading?: boolean;
}) {
	return (
		<Button
			htmlType={htmlType}
			icon={<ExportOutlined className="text-lg" />}
			loading={loading}
			disabled={loading}
			className="flex items-center !bg-transparent text-blue-500 border-0 px-0"
			onClick={() => {
				!!onClick && onClick();
			}}
		>
			{translate(`Export`)}
		</Button>
	);
}
